import { enLocalEntrega } from "./enums/enLocalEntrega";
import { DetalheFormaPagamentoModel } from "./FormaPagamentoModel";
import { LocalEntregaModel } from "./localEntregaModel";
import { DetalheProdutoModel } from "./produtoModel";

export class PedidoModel {
    constructor() {
        this.Sucesso = false;
    } 

    public Sucesso: boolean;
    public Mensagem: string;

    public RelacaoProvisoria: DetalhePedidoModel[];  
    public Relacao: DetalhePedidoModel[];  
}

export class DetalhePedidoModel{
    constructor() {
        this.Sucesso = false;
    } 

    public Sucesso: boolean;
    public Mensagem: string;
    
    public DataCriacao: Date;
    public ValorTotal: number;
    public Situacao: string;
    public CodigoStatus: number;
    public Codigo: string;
    public MotivoCancelamento: string;
    public TipoLocalEntrega: enLocalEntrega;
    public Cep: string;
    public Endereco: string;
    public Bairro: string;
    public Cidade: string;
    public NumeroResidencia: string;
    public Complemento: string;
    public DataCancelamento: Date;
    public DataAprovacao: Date;
    public DataUltimoPedido: Date;
    public DataEmissaoGuia: Date;
    public DataCupom: Date;
    public NomeCupom: string;
    public TempoAtendimento: string;
    public TaxaEntrega: number;
    public ValorDesconto: number;
    public UrlPagamento: string;
    public QrCode: string;
    public SegundosRestantes: string;

    public NomeCliente: string;
    public TelefoneCliente: string;
    public Cpf: string;
    public Observacao: string;

    public ValorProdutos: number;
    public FoiPago: boolean;
    
    public RelacaoProdutos: DetalheProdutoModel[];
    public RelacaoFormasPagamento: DetalheFormaPagamentoModel[];
    public LocalEntrega: LocalEntregaModel;

    // public enum enStatusCarrinhoCompras
    // {
    //     [Description("Aguardando aprovação")]
    //     AguardandoAprovacao = 9,

    //     [Description("Em preparo")]
    //     EmPreparacao = 1,

    //     //[Description("Pedido Preparado")]
    //     //Preparado = 3,

    //     [Description("Saiu para entrega")]
    //     SaiuParaEntrega = 4,

    //     [Description("Entregue")]
    //     Entregue = 5,

    //     [Description("Cancelado")]
    //     Cancelado = 6
    // }
}